import category from './category.api'
import channel from './channel.api'
import publication from './publication.api'
import mail from './mail.api'
import series from './series.api'
import comment from './comment.api'
import subscribe from './subscribe.api'
import pay from './pay.api'
import file from './file.api'
import user from './user.api'

export default {
  category,
  channel,
  publication,
  mail,
  series,
  comment,
  subscribe,
  pay,
  file,
  user
}